<template>
  <div>
      <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">添加账号</el-menu-item>
        <!-- <el-submenu index="2">
          <template slot="title">我的工作台</template>
          <el-menu-item index="2-1">选项1</el-menu-item>
          <el-menu-item index="2-2">选项2</el-menu-item>
          <el-menu-item index="2-3">选项3</el-menu-item>
          <el-submenu index="2-4">
            <template slot="title">选项4</template>
            <el-menu-item index="2-4-1">选项1</el-menu-item>
            <el-menu-item index="2-4-2">选项2</el-menu-item>
            <el-menu-item index="2-4-3">选项3</el-menu-item>
          </el-submenu>
        </el-submenu> -->
        <!-- <el-menu-item index="3" disabled>消息中心</el-menu-item> -->
        <!-- <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item> -->
      </el-menu>
      <router-view style="margin:10px"></router-view>
  </div>
</template>
<script>
export default {
  data(){
    return {
      activeIndex:'1'
    }
  },
  methods: {
      handleSelect(key, keyPath) {
        switch(key){
          case '1':
            this.$router.push('/admin/adminUser/addUser')
          break;
        }
      },
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminUser.vue